﻿import { PaymentFrequency } from '@core/_globals/types/sharedTypes';

export default class ApplicationsNonEmploymentIncome {
	frequency?: PaymentFrequency = null;
	amount?: number = null;
	description?: string = null;

	constructor(init?: ApplicationsNonEmploymentIncome) {
		if (init) {
			this.frequency = init.frequency;
			this.amount = init.amount;
			this.description = init.description;
		}
	}
}
